// extracted by mini-css-extract-plugin
export var blue = "br_dc";
export var dark = "br_cz";
export var gold = "br_dd";
export var gray = "br_df";
export var iconMain = "br_dk";
export var light = "br_cx";
export var magenta = "br_dj";
export var none = "br_dg";
export var orange = "br_dh";
export var original = "br_db";
export var root = "br_c9";
export var tan = "br_bZ";